import web from "@/core/middlewares/web";
import prefix from "@/core/utils/prefix-routes";
let index = () => import(/* webpackChunkName: "announcement" */ '@/views/announcements/Index');
let show = () => import(/* webpackChunkName: "announcement" */ '@/views/announcements/Show');
export default [
    ...prefix("/announcements", [
        {
            path: "",
            name: "announcements.index",
            component: index,
            meta: {
                middleware: web,
                 title: "اطلاعیه ها"
            }
        },
        {
            path: ":announcement",
            name: "announcements.show",
            component: show,
            meta: {
                middleware: web,
                 title: "نمایش اطلاعیه"
            }
        }

    ])
]
